import React from 'react'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'

type Props = {}

const OutputForm = (props: Props) => {
  return (
    <div>
        <Form className='queiryOutPut'>
            <div className='title'>
                <div className='left'>SQL_QUERY_AGENT/API</div>
            </div>
            <div className='outputframe'>
                <div>
                    <Label>Input</Label>
                    <Input
                        className='question'
                        id="question"
                        name="question"
                        placeholder=""
                        type="text"
                    ></Input>
                </div>
                <div>
                    <Label>generated_query</Label>
                    <Input
                        className='question'
                        id="question"
                        name="question"
                        placeholder=""
                        type="text"
                    ></Input>
                </div>
                <div>
                    <Label>summarized_output</Label>
                    <Input
                        className='question'
                        id="question"
                        name="question"
                        placeholder=""
                        type="text"
                    ></Input>
                </div>
            </div>
        </Form>
    </div>
  )
}

export default OutputForm